import {z} from 'zod';
import {toast} from 'react-toastify';
import React, {FC, useState} from 'react';
import {zodResolver} from '@hookform/resolvers/zod';
import {FormProvider, useForm} from 'react-hook-form';
import {VerdocsSpinner} from '@verdocs/web-sdk-react';
import {createOrganizationContact, VerdocsEndpoint} from '@verdocs/js-sdk';
import {Button, TextInput} from '../Components';
import {Dialog} from './Dialog';

const schema = z.object({
  email: z.string().trim().email('Invalid email').min(1, 'Email is required'),
  first_name: z.string().trim().min(1, 'First name is required'),
  last_name: z.string().trim().min(1, 'Last name is required'),
  phone: z.string().nullable(),
});

type SchemaType = z.infer<typeof schema>;

interface AddUserDialogProps {
  onClose?: () => void;
}

export const AddContactDialog: FC<AddUserDialogProps> = ({onClose = () => {}}) => {
  const [submitting, setSubmitting] = useState(false);

  const form = useForm<SchemaType>({
    mode: 'all',
    resolver: zodResolver(schema),
    defaultValues: {email: '', first_name: '', last_name: '', phone: ''},
  });

  const onSubmit = (data: any) => {
    console.log('sub', data);
    setSubmitting(true);
    return createOrganizationContact(VerdocsEndpoint.getDefault(), data)
      .then((r) => {
        console.log('r', r);
        setSubmitting(false);
        form.reset(r);
        toast.success('Contact added.');
        onClose();
      })
      .catch((e) => {
        console.log('e', e);
        setSubmitting(false);
        toast.error(`Error adding contact: ${e.response?.data?.error || e.message}`);
      });
  };

  return (
    <Dialog onCancel={onClose}>
      <div className="mb-4 text-lg font-medium text-[#33364b]">Add contact</div>
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <TextInput label="Email address" name="email" required />
          <TextInput label="First name" name="first_name" required />
          <TextInput label="Last name" name="last_name" required />
          <TextInput label="Phone number" name="phone" />

          <div className="mt-5 flex flex-row items-center justify-end gap-2">
            {submitting && <VerdocsSpinner mode="dark" />}
            <Button type="button" size="small" variant="secondary" label="Cancel" onClick={onClose} disabled={submitting} />
            <Button size="small" label="Add contact" type="submit" disabled={submitting} />
          </div>
        </form>
      </FormProvider>
    </Dialog>
  );
};
